import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'selectAll',
    'selectPayment',
    'form',
    'actions',
    'btnReceive'
  ];

  connect() {
    this.selectAllTarget.addEventListener('change', () => this.toggleAllCheckbox());
    this.element.querySelectorAll('.editable').forEach((el) => el.addEventListener('click', (ev) => this.onEditPaymentDateClick(ev.currentTarget)));
    $(this.element).on('change', 'input.payment-checkbox', () =>this.updateActions());
    $(this.element).on('change', 'input.submit-form', () => AjaxLoader.show() & this.formTarget.submit());

    $(this.element.querySelector('.select-payment-methods')).select2({
      escapeMarkup: (markup) => markup,
    }).on('select2:select', () => {
      this.updateContainerPaymentMethod();
    });
	}

  toggleAllCheckbox() {
    this.element.querySelectorAll('input[type="checkbox"].payment-checkbox').forEach((it) => {
      it.checked = this.selectAllTarget.checked;
    });

    this.updateActions();
  }

  updateContainerPaymentMethod(ev) {
    if (!ev)
      return;

    this.element.querySelectorAll(`[data-container]`).forEach(($el) => $el.classList.toggle('hidden', true));
    let el = this.element.querySelector(`[data-container="${this.selectPaymentTarget.selectedOptions[0].dataset.paymentMethod}"]`);
    !!el && el.classList.toggle('hidden', !ev.currentTarget.checked);
  }

  updateActions() {
    !!this.hasActionsTarget && this.actionsTarget.classList.toggle('hidden', this.element.querySelectorAll('input[type="checkbox"].payment-checkbox:checked').length == 0);
  }

  onEditPaymentDateClick(element) {
    let wrap = element.closest('.wrap');
    wrap.innerHTML = `<input type="text" class="money-mask form-control submit-form" value="${element.dataset.value}" style="width: 100px" name="${element.dataset.input}"/>`;

    if (element.dataset.editedInput) {
      wrap.innerHTML += `<input type="hidden" name="${element.dataset.editedInput}" value="true"/>`
    }

    element.remove();
  }

  cancelDiscount(ev) {
    ev.currentTarget.dataset.inputId && this.element.querySelector(`#${ev.currentTarget.dataset.inputId}`).remove();
    this.formTarget.submit()
  }

  receive(ev) {
    AjaxLoader.show();
    let btn = ev.currentTarget;
    !!btn.dataset.appendParamName && !!btn.dataset.appendParamValue && this.formTarget.insertAdjacentHTML('afterBegin', `<input type="hidden" value="${btn.dataset.appendParamValue}" name="${btn.dataset.appendParamName}" />`);
    this.formTarget.insertAdjacentHTML('afterBegin', `<input type="hidden" value="true" name="charge_tuitions" />`);
    this.formTarget.submit();
  }
}